import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _mergeProps({
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xml:space": "preserve",
    x: "0px",
    y: "0px",
    version: "1.1",
    viewBox: "0 0 44 44",
    class: "icon-fi icon-fi-users"
  }, _ctx.$attrs), _cache[0] || (_cache[0] = [
    _createStaticVNode("<g transform=\"translate(-0.375 -2.37)\" class=\"\"><path d=\"M27.4,33.4v-2c0-2.2-1.8-4-4-4h-8c-2.2,0-4,1.8-4,4v2\" class=\"icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke\"></path><circle cx=\"19.4\" cy=\"19.4\" r=\"4\" class=\"icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke\"></circle><path d=\"M33.4,33.4v-2c0-1.8-1.2-3.4-3-3.9\" class=\"icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke\"></path><path d=\"M26.4,15.5c2.1,0.5,3.4,2.7,2.9,4.9c-0.4,1.4-1.5,2.5-2.9,2.9\" class=\"icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke\"></path></g>", 1)
  ]), 16))
}
export default { render: render }